import FeaturesCard from "./FeaturesCard";

export default FeaturesCard;